/**
 * 🦾 Custom script by BoostEcom
 * Badge « Économisez X € » du bloc prix (blocks/price.liquid, zone 🦾 BoostEcom).
 * Remplace le script inline du live : écoute l'événement natif de changement de variante
 * (StandardEvents.productSelect) et reprend le badge rendu côté serveur pour la nouvelle variante.
 */
import { StandardEvents } from '@shopify/events';

class SavingBadgeBoostecom extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const next = detail?.html?.querySelector(`saving-badge-boostecom[data-block-id="${this.dataset.blockId}"]`);
        if (next) this.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('saving-badge-boostecom')) {
  customElements.define('saving-badge-boostecom', SavingBadgeBoostecom);
}
